import React from 'react';
import thetaIntelligenceIcon from '../../assets/icons/home/theta-intelligence.svg';
import checkmarkIcon from '../../assets/icons/home/checkmark.svg';

const CheckItem = ({children}) => (
    <div className={'AIAgents__check-item'}>
        <img className={'AIAgents__check-icon'} src={checkmarkIcon} alt={''} />
        <span>{children}</span>
    </div>
);

const EnterpriseAIAgentsSection = () => {
    return (
        <div className={'AIAgents-wrapper'}>
        <div className={'AIAgents'}>
            <div className={'AIAgents__header'}>
                <div className={'AIAgents__section-label'}>
                    <span>Production Ready</span>
                    <div className={'AIAgents__section-label-line'}/>
                </div>
                <h2 className={'AIAgents__headline'}>Enterprise AI Agents</h2>
                <p className={'AIAgents__subtitle'}>
                    Deploy production-ready AI agents without building or managing
                    infrastructure yourself.
                </p>
            </div>

            <div className={'AIAgents__cards'}>
                <div className={'AIAgents__card'}>
                    <h3 className={'AIAgents__card-title'}>AI Agent Platform</h3>
                    <p className={'AIAgents__card-description'}>
                        Deploy conversational AI for customer support. Used by
                        Olympique Marseille and Houston Rockets for Multilingual
                        fan engagement
                    </p>
                    <div className={'AIAgents__card-checklist'}>
                        <CheckItem>Pre-built AI-agents for website and Discord</CheckItem>
                        <CheckItem>Custom knowledge base integration</CheckItem>
                        <CheckItem>Multilingual support out of the box</CheckItem>
                        <CheckItem>Hands-on support from the start</CheckItem>
                    </div>
                    <a className={'AIAgents__card-cta AIAgents__card-cta--teal'}
                       href={'https://www.thetaedgecloud.com/ai-agents'}
                       target={'_blank'}
                       rel={'noopener noreferrer'}
                    >
                        Explore AI Agents →
                    </a>
                </div>

                <div className={'AIAgents__card AIAgents__card--purple'}>
                    <div className={'AIAgents__card-icon-row'}>
                        <img className={'AIAgents__card-icon'}
                             src={thetaIntelligenceIcon}
                             alt={'Theta Intelligence'}
                        />
                        <h3 className={'AIAgents__card-title'}>
                            Unlock Insights with<br/>Theta Intelligence
                        </h3>
                    </div>
                    <p className={'AIAgents__card-description'}>
                        Turn customer conversations into strategic insights. Real-time
                        analytics reveal operational issues, content opportunities, and
                        revenue drivers before traditional metrics catch them.
                    </p>
                    <div className={'AIAgents__card-checklist'}>
                        <CheckItem>Track topics, trends, and sentiment in real-time</CheckItem>
                        <CheckItem>Get alerts when question patterns spike</CheckItem>
                        <CheckItem>Map customer needs throughout events with timestamps</CheckItem>
                        <CheckItem>Export to your existing business tools</CheckItem>
                    </div>
                    <a className={'AIAgents__card-cta AIAgents__card-cta--purple'}
                       href={'https://www.thetaedgecloud.com/ai-agents/demo/stats'}
                       target={'_blank'}
                       rel={'noopener noreferrer'}
                    >
                        <span>Explore Theta Intelligence →</span>
                    </a>
                </div>
            </div>
        </div>
        </div>
    );
};

export default EnterpriseAIAgentsSection;
